import React from 'react';
import PropTypes from 'prop-types'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

const defaultProps = {
    children: null,
    className: ''
};

function MessageBar({ children, className }) {
    return (
        <div className={`message-bar ${className}`}>
            {children}
        </div>
    );
}

MessageBar.propTypes = propTypes;
MessageBar.defaultProps = defaultProps;

export default MessageBar;